import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { FetchDeviceQuery, FetchSubDevicesQuery } from '@/lib/api/devices/devices';
import { SecondaryDeviceFullDto, SortOrder } from '@/lib/api/types.gen';
import { SearchEventsQuery } from '@/lib/api/monitoring/events';

export const useCurrentDevice = () => {
  const { deviceId } = useParams<{ deviceId: string }>();
  return useQuery(FetchDeviceQuery({ deviceId: deviceId ?? '' }));
};

export const getVideoProcessorId = (camera?: SecondaryDeviceFullDto) => {
  return camera ? `__ihub/${camera.videoProcessorId?.deviceId ?? ''}/${camera.videoProcessorId?.value ?? ''}` : undefined;
};

export const useDeviceEvents = () => {
  const { data: device } = useCurrentDevice();
  const subDevicesQuery = useQuery(FetchSubDevicesQuery({ deviceId: device?.id ?? '' }));
  const subDevices = subDevicesQuery.data ?? [];
  const { cameraId } = useParams<{ cameraId: string }>();
  const camera = subDevices.find((c) => c.id === cameraId);
  const videoProcessorId = getVideoProcessorId(camera!);
  const {
    data: events,
    isLoading,
    error,
  } = useQuery({
    ...SearchEventsQuery({
      companyId: device?.customerId ?? "",
      projectId: device?.projectId ?? "",
      videoProcessorId: videoProcessorId ?? '',
      limit: 10,
      sortDir: SortOrder.Ascending,
      sortBy: "occurred"
    }),
    enabled:
      !!device?.customerId &&
      !!device?.projectId &&
      !!camera,
    staleTime: 30_000,
  });

  return {
    events: events?.rows ?? [],
    isLoading,
    error,
  };
};
